import React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import {
  openDeleteKmz,
  selectedKmz,
  selectedDisplayedKmz,
  selectedRouteOnMap,
  selectedNavRouteAtom,
  kmzNetwork,
} from '../../common/atom/atoms';
import { deleteKmzWithStatePreservation } from './functions/delete_kmz_with_state_preservation.function';
import { useBackdrop } from '../../common/components/backDrop_context.component';
import { notify } from '../../common/functions/react-toastify.function';
import { DeleteRoute } from './functions/delete_Route.function';
import { logout } from '../../common/functions/log_out.function';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  borderRadius: '5px',
  p: 4,
};

export default function DeleteKmzComponent(props) {
  const { map, getAllKmz, getAllRoutes, setKmzData, filters } = props;
  const [openKmzDeleteModal, setOpenKmzDeleteModal] = useAtom(openDeleteKmz);
  const [selectedKmzIds, setSelectedKmzIds] = useAtom(selectedDisplayedKmz);
  const { showBackdrop, hideBackdrop } = useBackdrop();
  const [selectedKmzs, setSelectedKmz] = useAtom(selectedKmz);

  const network = useAtomValue(kmzNetwork);
  const [selectedRouteOnMapValue, setSelectedRouteOnMapValue] = useAtom(selectedRouteOnMap);
  const setSelectedNavRoute = useSetAtom(selectedNavRouteAtom);

  const handleDeleteKmz = async () => {
    showBackdrop();
    try {
      const resp = await deleteKmzWithStatePreservation(
        selectedKmzs.name,
        network,
        selectedKmzIds,
        setKmzData,
        setSelectedKmzIds,
        filters
      );

      setSelectedKmz(null);
      hideBackdrop();
      setOpenKmzDeleteModal(false);
      notify('success', resp.message);
    } catch (error) {
      hideBackdrop();
      notify('error', 'something went wrong');
      setOpenKmzDeleteModal(false);
    }
  };
  const handleDeleteRoute = async () => {
    showBackdrop();
    try {
      const resp = await DeleteRoute(selectedRouteOnMapValue.id);
      getAllRoutes();
      hideBackdrop();
      setOpenKmzDeleteModal(false);
      setSelectedKmzIds([]);
      setSelectedNavRoute(null);
      notify('success', resp?.message || 'Route deleted successfully');
    } catch (error) {
      hideBackdrop();
      notify('error', 'something went wrong');
      setOpenKmzDeleteModal(false);
    }
  };
  const handleClose = () => {
    setSelectedKmz(null);
    setSelectedNavRoute(null);
    setSelectedRouteOnMapValue(null);
    setOpenKmzDeleteModal(false);
  };
  console.log('kk', selectedKmzs);
  return (
    <div>
      <Modal
        open={openKmzDeleteModal}
        onClose={() => handleClose()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div
            style={{
              width: 500,
              height: 136,
              background: 'white',
              borderRadius: 12,
              flexDirection: 'column',
              justifyContent: 'flex-start',
              alignItems: 'center',
              display: 'inline-flex',
            }}
          >
            <div style={{ width: '100%' }}>
              <div
                data-svg-wrapper
                style={{ position: 'relative', cursor: 'pointer' }}
                onClick={() => handleClose()}
              >
                <svg
                  width="24"
                  style={{ float: 'right' }}
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.5859 12.0001L2.79297 4.20718L4.20718 2.79297L12.0001 10.5858L19.793 2.79297L21.2072 4.20718L13.4143 12.0001L21.2072 19.7929L19.793 21.2072L12.0001 13.4143L4.20718 21.2072L2.79297 19.7929L10.5859 12.0001Z"
                    fill="#BD1D23"
                  />
                </svg>
              </div>
            </div>
            <div
              style={{
                width: 486,
                textAlign: 'center',
                color: 'black',
                fontSize: 20,
                fontFamily: 'Poppins',
                fontWeight: '500',
                wordWrap: 'break-word',
              }}
            >
              Are you sure, want to delete{' '}
              <span
                style={{
                  color: '#FF6B35',
                  fontWeight: '700',
                  fontSize: 22,
                }}
              >
                {selectedRouteOnMapValue ? selectedRouteOnMapValue.routeName : selectedKmzs?.name}
              </span>
              ?{' '}
            </div>
            <div
              style={{
                width: 85,
                paddingLeft: 12,
                paddingRight: 12,
                paddingTop: 15,
                paddingBottom: 15,
                background: '#BD1D23',
                marginTop: '10%',
                boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
                borderRadius: 4,
                overflow: 'hidden',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'inline-flex',
              }}
            >
              <div
                onClick={selectedRouteOnMapValue ? handleDeleteRoute : handleDeleteKmz}
                style={{
                  paddingLeft: 8,
                  paddingRight: 8,
                  cursor: 'pointer',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: 10,
                  display: 'flex',
                }}
              >
                <div
                  style={{
                    color: 'white',
                    fontSize: 14,
                    fontFamily: 'Poppins',
                    fontWeight: '500',
                    wordWrap: 'break-word',
                  }}
                >
                  Delete
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
